/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedMembershipPlanList } from '../models/PaginatedMembershipPlanList';
import { request as __request } from '../core/request';

export class MembershipPlansService {

    /**
     * @param page A page number within the paginated result set.
     * @returns PaginatedMembershipPlanList
     * @throws ApiError
     */
    public static async membershipPlansList(
        page?: number,
    ): Promise<PaginatedMembershipPlanList> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/membership-plans`,
            query: {
                'page': page,
            },
        });
        return result.body;
    }

}